import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartIframeComponent } from './start/start-iframe.component';
import { ActivitiesListComponent } from './activity/activities.list.component';
import { AccountingListComponent } from './accounting/accounting.list.component';
import { ClosingListComponent } from './closing/closing.list.component';
import { IncomeStatementListComponent } from './incomestatement/incomestatement.list.component';
import { SalaryListComponent } from './salary/salary.list.component';
import { IncomeTaxDeclarationListComponent } from './incometaxdeclaration/incometaxdeclaration.list.component';
import { TaxDeclarationListComponent } from './taxdeclaration/taxdeclaration.list.component';
import { TodoListComponent } from './todo/todo.list.component';
// import { AdvisoryToolComponent } from './advisory-tool/components/advisory-tool.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { MainAppComponent } from './start/main-app.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { SilentAuthComponent } from './login/silent-auth.component';
import { ClientListComponent } from './client/client.list.component';
import { CompositeType } from './core/state/types';
import { SustainabilityReportingComponent } from './sustainability-reporting/sustainability-reporting.component';
import { CollaborationPackagesComponent } from './collaboration-packages/collaboration-packages.component';
import { PartnerProgramComponent } from './partnerprogram/partnerprogram.component';
import { BlaAuthComponent } from './login/bla-auth.component';
import { jwtParamGuard } from './core/guards/jwt-param.guard';
import { guideResolver } from './core/resolvers/guide.resolver';
import { countryGuard } from './core/guards/country.guard';
import { AnalyticsCategory } from './core/entity/analytics/analytics-categories';

const appRoutes: Routes = [
  // this path is used by the SSO login / Gateway as redirect uri after successfully login
  { path: 'auth', component: SilentAuthComponent },
  // this path is used by BLA to login with their JWT token
  { path: 'blaauth', component: BlaAuthComponent, canActivate: [jwtParamGuard] },

  { path: 'login', component: LoginComponent, data: { analytics: { title: 'Login' } } },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: MainAppComponent,
    children: [
      { path: '', component: StartIframeComponent, data: { analytics: { title: 'Start' } } },
      { path: 'start', component: StartIframeComponent, data: { analytics: { title: 'Start' } } },
      // {
      //   path: 'advisorytool',
      //   component: AdvisoryToolComponent,
      //   canActivate: [countryGuard('SE')],
      //   data: { analytics: { title: AnalyticsCategory.AdvisoryTools } },
      // },
      {
        path: 'activities',
        component: ActivitiesListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.AllActivities } },
      },
      {
        path: CompositeType.accounting,
        component: AccountingListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.Accounting } },
      },
      {
        path: CompositeType.salaries,
        component: SalaryListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.Salary } },
      },
      {
        path: CompositeType.closing,
        component: ClosingListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.AnnualReport } },
      },
      {
        path: CompositeType.incomeStatement,
        component: IncomeStatementListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.StatementOfIncome } },
      },
      {
        path: CompositeType.incomeTaxDeclaration,
        component: IncomeTaxDeclarationListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.IncomeTaxReturn } },
      },
      {
        path: CompositeType.taxDeclaration,
        component: TaxDeclarationListComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.TaxDeclaration } },
      },
      {
        path: 'clients/guide',
        component: ClientListComponent,
        resolve: { guideData: guideResolver },
        data: { analytics: { title: 'Clients Guide' } },
      },
      { path: 'clients', component: ClientListComponent, data: { analytics: { title: AnalyticsCategory.Clients } } },
      { path: 'todo', component: TodoListComponent, data: { analytics: { title: AnalyticsCategory.ToDo } } },
      {
        path: 'notifications',
        component: NotificationsComponent,
        data: { analytics: { title: AnalyticsCategory.Notifications } },
      },
      {
        path: 'sustainability',
        component: SustainabilityReportingComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.SustainabilityReporting } },
      },
      {
        path: 'collaborationpackages',
        component: CollaborationPackagesComponent,
        data: { analytics: { title: AnalyticsCategory.CollaborationBundles } },
      },
      {
        path: 'partnerprogram',
        component: PartnerProgramComponent,
        canActivate: [countryGuard('SE')],
        data: { analytics: { title: AnalyticsCategory.PartnerProgram } },
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes, {});
